import { Link } from 'react-router';
import {
  LithostratTargetType,
  type LithostratOutcropLinkPartsFragment,
} from '~/apollo/generated/v4/graphql';
import {
  lithostratFormationRoute,
  lithostratGroupRoute,
  lithostratMemberRoute,
} from '~/paths';

type Props = {
  lithostratLink: LithostratOutcropLinkPartsFragment;
  // | LithostratStudyLinkPartsFragment;
};

export function LithostratWikiLink({ lithostratLink }: Props) {
  const { targetType, targetId, targetName } = lithostratLink;

  if (!targetId) return <>{targetName}</>;

  let route;
  switch (targetType) {
    case LithostratTargetType.Formation:
      route = lithostratFormationRoute(targetId);
      break;
    case LithostratTargetType.Group:
      route = lithostratGroupRoute(targetId);
      break;
    case LithostratTargetType.Member:
      route = lithostratMemberRoute(targetId);
      break;
    default:
      throw new Error(
        `Unhandled lithostrat outcrop link parent type '${targetType}'.`,
      );
  }

  return (
    <Link to={route} className="link">
      {targetName}
    </Link>
  );
}
